<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="问题" prop="title">
        <el-input v-model="form.title" placeholder="请输入" maxlength="50" show-word-limit style="width: 570px" />
      </el-form-item>
      <el-form-item label="回答" prop="content">
        <div v-for="(item,index) in form.content" :key="index" class="ipt-box">
          <el-input v-model="item.content" placeholder="请输入" maxlength="50" show-word-limit style="width: 570px" />
          <i class="el-icon-plus" @click="handleAddItem"></i>
          <i class="el-icon-minus" @click="handleDeleteItem(index)"></i>
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceInfoLibraryApi from '@/api/customer/custServiceInfoLibrary'
import custServiceInfoLibraryContent from '@/api/customer/custServiceInfoLibraryContent'
function initFormBean() {
  const formBean = {
    content: [{ content: '', infoLibraryId: 0 }],
    isEnable: false,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: '请输入问题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入回答', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.getContent()
    },
    getContent() {
      custServiceInfoLibraryContent.fetchList({ infoLibraryId: this.form.id }).then((res) => {
        let arr = []
        res.data.forEach(item => {
          arr.push({ content: item.content, infoLibraryId: item.id })
        });
        this.$set(this.form, 'content', arr)
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            custServiceInfoLibraryApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            custServiceInfoLibraryApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.content.splice(index, 1)
    },
    handleAddItem() {
      this.form.content.push({ content: '', infoLibraryId: 0 })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
